import React from 'react'
import { Badge } from '@/components/shared/atoms/Badge'
import { formatCurrency } from '@/utils/formatCurrency'
import { ProductDto } from '@wtf/shared'
import { useDisplayPrice } from '@/hooks/useDisplayPrice'

interface ProductOverlayProps {
    product: ProductDto
    variant: 'left' | 'bottom'
}

export const ProductOverlay: React.FC<ProductOverlayProps> = ({
    product,
    variant,
}) => {
    const { brand, price, currency } = product
    const { displayPrice, displayCurrency } = useDisplayPrice(price, currency)
    const formattedPrice = formatCurrency(displayPrice, displayCurrency, true)

    if (variant === 'left') {
        return (
            <>
                {/* Top Left Price Badge - Mobile */}
                {typeof price === 'number' && (
                    <div className="absolute top-1 left-1">
                        <Badge
                            className="py-[6px] backdrop-blur-2xl"
                            icon={null}
                            label={formattedPrice}
                        />
                    </div>
                )}

                {/* Bottom Left Brand Text - Mobile */}
                {brand && (
                    <p
                        className="text-13 absolute right-1 bottom-1 left-1 w-auto bg-transparent px-3 py-[6px] font-medium text-white md:right-2 md:bottom-2 md:left-2"
                        style={{ textShadow: '0px 0px 20px #000000' }}
                    >
                        {brand}
                    </p>
                )}
            </>
        )
    }

    if (variant === 'bottom') {
        return (
            <div className="absolute right-1 bottom-1 left-1 flex items-center justify-between md:right-2 md:bottom-2 md:left-2">
                {/* Bottom Left Brand Text - Desktop */}
                {brand && (
                    <p
                        className="w-auto bg-transparent px-3 text-sm font-medium text-white"
                        style={{ textShadow: '0px 0px 20px #000000' }}
                    >
                        {brand}
                    </p>
                )}

                {/* Bottom Right Price Badge - Desktop */}
                {typeof price === 'number' && (
                    <Badge
                        className="self-end rounded-xl !bg-black/32 px-3 !backdrop-blur-3xl"
                        icon={null}
                        label={formattedPrice}
                    />
                )}
            </div>
        )
    }

    return null
}
